var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "column" }, [
    _c(
      "div",
      { staticClass: "quote-header tile is-ancestor is-parent pl-0" },
      [
        _vm.value
          ? _c("booking-vehicle", {
              attrs: { "show-box": true },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            })
          : _vm._e(),
        _vm.value
          ? _c("booking-customer", {
              attrs: { "show-box": true },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            })
          : _vm._e(),
        _vm.value
          ? _c("booking-claim", {
              attrs: { "show-box": true },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            })
          : _vm._e(),
        _vm.value
          ? _c("booking-extra", {
              attrs: { "show-box": true },
              model: {
                value: _vm.value,
                callback: function ($$v) {
                  _vm.value = $$v
                },
                expression: "value",
              },
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }